<template>
  <div>
    <template v-if="!manual">
      <address-autocomplete
          :value="value"
          :label="$t('onboarding.address.search')"
          :hint="$t('onboarding.address.search-hint')"
          required
          @input="picked"
      />
      <v-btn small text color="primary" class="px-1 mb-2" @click="manual = true">{{ $t('onboarding.address.enter-manually') }}</v-btn>
    </template>

    <v-row v-else dense>
      <v-col cols="4" sm="3">
        <v-text-field :value="value && value.number" :label="$t('onboarding.tunnel.field.number')" outlined dense @input="typed('number', $event)" />
      </v-col>
      <v-col cols="8" sm="9">
        <v-text-field :value="value && value.street" :label="$t('onboarding.tunnel.field.street')" :rules="[required]" outlined dense @input="typed('street', $event)" />
      </v-col>
      <v-col cols="4">
        <v-text-field :value="value && value.zipcode" :label="$t('onboarding.tunnel.field.zipcode')" :rules="[required]" outlined dense @input="typed('zipcode', $event)" />
      </v-col>
      <v-col cols="8">
        <v-text-field :value="value && value.city" :label="$t('onboarding.tunnel.field.city')" :rules="[required]" outlined dense @input="typed('city', $event)" />
      </v-col>
      <v-col cols="12">
        <v-btn small text color="primary" class="px-1 mb-2" @click="manual = false">{{ $t('onboarding.address.search-instead') }}</v-btn>
      </v-col>
    </v-row>

    <!-- Google ne connaît ni le bâtiment ni l'étage : le complément se donne toujours à la main. -->
    <v-text-field
        :value="value && value.additionalInformation"
        :label="$t('onboarding.tunnel.field.additional-information')"
        outlined
        dense
        @input="$emit('input', { ...emptyAddress, ...value, additionalInformation: $event })"
    />
  </div>
</template>

<script>
import AddressAutocomplete from './AddressAutocomplete.vue'

const EMPTY_ADDRESS = { number: '', street: '', additionalInformation: '', zipcode: '', city: '', country: 'FR' }

/**
 * Une adresse du tunnel : cherchée chez Google, comme partout ailleurs, pour qu'elle arrive juste et
 * placée sur la carte ; saisie à la main seulement quand Google ne la trouve pas.
 */
export default {
  name: 'TunnelAddressField',

  components: { AddressAutocomplete },

  props: {
    /** { number, street, additionalInformation, zipcode, city, country, coordinates? } */
    value: { type: Object, default: null },
  },

  data() {
    return {
      manual: false,
      emptyAddress: EMPTY_ADDRESS,
    }
  },

  methods: {
    required(value) {
      return !!(value && String(value).trim()) || this.$t('onboarding.tunnel.field.required')
    },

    /** Le complément déjà donné survit au choix d'une adresse : Google n'en propose presque jamais. */
    picked(address) {
      if (!address) {
        this.$emit('input', { ...EMPTY_ADDRESS })
        return
      }
      this.$emit('input', { ...address, additionalInformation: address.additionalInformation || this.value?.additionalInformation || '' })
    },

    /** Retouchée à la main, l'adresse n'est plus celle que Google a placée : ses coordonnées tombent. */
    typed(field, text) {
      // eslint-disable-next-line no-unused-vars
      const { coordinates, ...address } = { ...EMPTY_ADDRESS, ...this.value }
      this.$emit('input', { ...address, [field]: text })
    },
  },
}
</script>
